import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid,Chip, Button, Typography } from '@material-ui/core';

import KPTable from '../../../../components/KPTComponents/KPTable';
import PopupMenu from '../../../../components/CustomComponents/PopupMenu';
import PreviewModal from '../../../../components/CustomComponents/PreviewModal';
import DuyetThanhTichModal from '../../../../components/CustomComponents/DuyetThanhTichModal';

import DuAnUpdate from '../DuAnUpdate';
import { researchProjectActions } from '../../../../actions';
import { RESEARCHPROJECTS_CONSTANTS } from '../../../../constants';

export default function DuAnTable(props) {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.researchProjectReducer.loading);
  const researchProjectList = useSelector(state => state.researchProjectReducer.researchProjectList);
  const totalResearchProjectList = useSelector(state => state.researchProjectReducer.totalResearchProjectList);
  const { LEVEL_OPTIONS } = RESEARCHPROJECTS_CONSTANTS;

  const [values, setValues] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const [detail, setDetail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(false);
  
  const openDeleteMenu = (e, id) => {
    setDeleteId(id);
    setDeleteMenuAnchor(e.currentTarget);
  }
  const closeDeleteMenu = () => {
    setDeleteId(null);
    setDeleteMenuAnchor(null);
  }

  const handleDelete = () => {
    dispatch(researchProjectActions.deleteResearchProject(deleteId));
    closeDeleteMenu();
  }

  const handleAccepted = (row = duyetThanhTich) => {
    dispatch(researchProjectActions.updateResearchProjectAccepted(
      [{
        id: row.formResearchProjectId,
        accepted: !row.thanhTichAccepted,
        score: values?.score || 0,
        note: values?.note || '',
      }]
    ));
    setDuyetThanhTich(null);
    setValues(null);
  }
  
  const mobileMode = window.innerWidth <= 768;

  // var tableRows = (props.filterType === 'person') ? researchProjectList : totalResearchProjectList;

  var tableRows = [];
  if (props?.rows) {
    tableRows = props?.rows;
  } else {
    tableRows = props.filterType === 'person' ? researchProjectList : totalResearchProjectList;
  }

  tableRows = tableRows?.map((e) => ({
    ...e,
    startAt: dayjs(e.startAt).format('DD/MM/YYYY'),
    finishAt: dayjs(e.finishAt).format('DD/MM/YYYY'),
  }));

  var columns = [
    { title: <b>STT</b>, dataIndex: 'id', width: '5%', render: (_, row, id) => id + 1 },
    {
      title: <b>Tên đề tài/dự án</b>,
      dataIndex: 'title',
      width: props.type === 'update' ? '40%' : '45%',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Cấp dự án</b>,
      dataIndex: 'level',
      width: '25%',
      render: (value) => LEVEL_OPTIONS.find((e) => e.value === value)?.title,
    },
    // {
    //   title: <b>Vai trò</b>,
    //   dataIndex: 'type',
    //   width: '15%',
    //   render: (value) => typeOptions.find((e) => e.value === value)?.title,
    // },
    {
      title: <b>Tình trạng</b>,
      dataIndex: 'thanhTichAccepted',
      width: '15%',
      filters: [
        { text: 'Đã được duyệt', value: true },
        { text: 'Chưa được duyệt', value: false }
      ],
      onFilter: (value, row) => row.thanhTichAccepted === value,
      render: (value) => (
        <Chip
          size='small'
          variant='outlined'
          color={value ? 'primary' : 'default'}
          label={`${value ? 'Đã' : 'Chưa'} duyệt`}
          style={{ width: '100%' }}
        />
      )
    },
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'cc-actions',
      width: '15%',
      render: (_, row) => (
        <>
          <Typography variant='body2' color='primary' className='actions-button' onClick={() => setDetail(row)}>Chi tiết</Typography>
          {!(props.type === 'accept') && (
            <Typography
              variant='body2'
              color='secondary'
              className='actions-button'
              onClick={(e) => openDeleteMenu(e, row.id)}
            >
              Xoá
            </Typography>
          )}
          <Typography variant='body2' className='actions-button' onClick={() => setPreview(row?.link)}>Minh chứng</Typography>
          {(props.type === 'accept') && (
            <Typography
              variant='body2'
              color={row?.thanhTichAccepted ? 'secondary' : 'primary'}
              className='actions-button'
              onClick={() => {
                if (row?.thanhTichAccepted) handleAccepted(row); else setDuyetThanhTich(row);
              }}
            >
              {`${row?.thanhTichAccepted ? 'Huỷ xác' : 'Xác'} nhận`}
            </Typography>
          )}
        </>
      ),
    },
  ];

  if (props.type === 'accept') {
    columns = [
      { ...columns[0] },
      {
        title: <b>Thông tin thành tích</b>,
        dataIndex: 'title',
        width: '50%',
        render: (_, row) => (
          <>
            <Typography variant='body2'><b>Tên đề tài/dự án: </b>{row.title}</Typography>
            <Typography variant='body2'>
              <b>Cấp dự án: </b>
              {LEVEL_OPTIONS.find((e) => e.value === row.level)?.title}
            </Typography>
            {/* <Typography variant='body2'>
              <b>Vai trò: </b>
              {typeOptions.find((e) => e.value === row.type)?.title}
            </Typography> */}
          </>
        ) 
      },
      { title: <b>Điểm</b>, dataIndex: 'score', width: '5%' },
      { title: <b>Ghi chú</b>, dataIndex: 'note', width: '15%' },
      { ...columns[4], width: '15%' },
      { ...columns[5], width: '10%' },
    ];
  }

  if (props.type === 'update') {
    if (mobileMode) {
      columns = [
        {...columns[1], title: <b>Tiêu đề</b>, width: '45%'},
        {...columns[3], width: '30%'},
        {...columns[4], width: '25%'},
      ];
    } else {
      columns = [
        {...columns[0], width: '5%'},
        {...columns[1], width: '45%'},
        {...columns[2], width: '25%'},
        {...columns[3], width: '15%'},
        {...columns[4], width: '15%'},
      ];
    }
  }

  return (
    <Grid item xs={12}>
      <KPTable
        nonBorder={props.type === 'accept'}
        columns={columns}
        rows={tableRows}
        loading={loading}
      />

      <DuAnUpdate detail={detail} onClose={() => setDetail(null)} />

      <PopupMenu
        position='center'
        anchorEl={deleteMenuAnchor}
        handleClose={closeDeleteMenu}
        render={
          <div style={{ padding: 8, boxSizing:'border-box' }}>
            <Typography style={{ paddingBottom: 16 }}>Xác nhận xoá đề tài nghiên cứu?</Typography>
            <Button variant='outlined' style={{ width: 'calc(50% - 4px)',fontSize:'12px' }} onClick={closeDeleteMenu}>Huỷ</Button>
            <Button variant='contained' color='secondary' style={{ marginLeft: 8, width: 'calc(50% - 4px)', fontSize:'12px' }} onClick={handleDelete}>Xác nhận</Button>
          </div>
        }
      />

      <PreviewModal
        open={!!preview}
        url={preview}
        handleClose={() => setPreview(null)}
      />
      
      <DuyetThanhTichModal
        type='formResearchProject'
        info={duyetThanhTich}
        values={values}
        setValues={setValues}
        open={!!duyetThanhTich}
        handleClose={() => setDuyetThanhTich(null)}
        handleSubmit={handleAccepted}
      />
    </Grid>
  );
}